import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  ErrorBox,
  Form,
} from "@gearbox-protocol/deploy-tools-ui";
import {
  api,
  type TaskDefinitionFormOverrideSchema,
  taskDefinitionFormOverrideSchema,
} from "api";
import { type FC, useMemo } from "react";
import { useToggle } from "react-use";
import { preventSubmitOnEnter } from "utils";

import {
  TaskDefinitionConstructor,
  TaskDefinitionIdInput,
  TaskDefinitionsProvider,
  useTaskDefinitionForm,
} from "../task-definitions";

interface StartTaskDialogProps {
  executionId: string;
  toggleOpen: (open: boolean) => void;
}

const StartTaskDialog: FC<StartTaskDialogProps> = props => {
  const { executionId, toggleOpen } = props;
  const [full, toggleFull] = useToggle(false);
  const className = full
    ? "max-w-[calc(100%-64px)] w-[calc(100%-64px)] max-h-[calc(100%-64px)] h-[calc(100%-64px)] flex flex-col overflow-y-scroll"
    : "sm:max-w-[425px]";

  const onSubmit = useMemo(
    () => async (v: TaskDefinitionFormOverrideSchema) => {
      await api.startTask(executionId, v);
      toggleOpen(false);
      // TODO: redirecto to task page
    },
    [executionId, toggleOpen],
  );

  const { form, error, submit } = useTaskDefinitionForm({
    schema: taskDefinitionFormOverrideSchema,
    defaultValues: { id: "" },
    onSubmit,
  });

  return (
    <TaskDefinitionsProvider>
      <Dialog open={true} onOpenChange={toggleOpen}>
        <DialogContent className={className}>
          <DialogHeader>
            <DialogTitle>Start task</DialogTitle>
            <DialogDescription>Start task on this testnet</DialogDescription>
          </DialogHeader>

          <Form {...form}>
            <form
              onSubmit={submit}
              onKeyDown={preventSubmitOnEnter}
              className="space-y-2"
            >
              <TaskDefinitionIdInput />

              {full && (
                <TaskDefinitionConstructor
                  form={form as any}
                  hideArtifacts={true}
                />
              )}
            </form>
          </Form>

          {!!error && <ErrorBox error={error} />}

          <DialogFooter>
            {!full && (
              <Button variant="ghost" onClick={toggleFull}>
                Override settings
              </Button>
            )}
            <Button
              type="submit"
              disabled={form.formState.isSubmitting}
              loading={form.formState.isSubmitting}
              onClick={submit}
            >
              Start
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </TaskDefinitionsProvider>
  );
};

export default StartTaskDialog;
